import { render, staticRenderFns } from "./LoginTokenTema.vue?vue&type=template&id=72c70a40"
import script from "./LoginTokenTema.vue?vue&type=script&lang=js"
export * from "./LoginTokenTema.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports